import {getHashJsonStringifyObject} from "../utils/hashCode";
import {GREEN_COLOR_JS, YELLOW_BACKGROUND_JS} from "../utils/consts";
import _ from "lodash";

export const status = {
  created: 'created', // Новый
  draft: 'draft', // Черновик
  onApprovePortf: 'onApprovePortf', // У руководителя портфеля (только для портфельных)
  returnedByPortf: 'returnedByPortf', // На доработке (руководитель портфеля)
  onApproveHeadSP: 'onApproveHeadSP', // У руководителя СП
  returnedByHeadSP: 'returnedByHeadSP', // На доработке (руководитель СП)
  // onApprovePolicy: 'onApprovePolicy', // У координатора направления (только для ЦТ)
  // returnedByPolicy: 'returnedByPolicy', // На доработке (координатор направления)
  onApproveExperts: 'onApproveExperts', // На рассмотрении ЭГ
  returnedByExperts: 'returnedByExperts', // На доработке (экспертная группа)

  // только для проектов политик, без СП
  onApproveCommittee: 'onApproveCommittee', // На рассмотрении ЦК (только для ЦТ)
  returnedByCommittee: 'returnedByCommittee', // На доработке (цифровой комитет)
  committeeApproved: 'committeeApproved', // Одобрен ЦК
  committeeDeclined: 'committeeDeclined', // Отклонен ЦК

  expertsApproved: 'expertsApproved', // Одобрен ЭГ
  expertsDeclined: 'expertsDeclined', // Отклонен ЭГ

  prolongation: 'prolongation', // Пролонгация
  approved: 'approved', // Утвержден
  '-approved': '-approved', // Утвержден (нет файла)
  closed: 'closed', // закрыт
  moved: 'moved' // перемещен
};

export const status_ru = {
  draft: 'Черновик',
  onApprovePortf: 'У руководителя портфеля',
  returnedByPortf: 'На доработке',
  onApproveHeadSP: 'У руководителя СП',
  onApproveHeadPolicy: 'У руководителя политики',
  onApproveHeadGoal: 'У руководителя цели',
  onApproveHeadTech: 'У руководителя СТП',
  returnedByHeadSP: 'На доработке',
  onApproveExperts: 'На рассмотрении ЭГ',
  returnedByExperts: 'На доработке',

  onApproveCommittee: 'На рассмотрении ЦК',
  returnedByCommittee: 'На доработке',
  committeeApproved: 'Одобрен ЦК',
  committeeDeclined: 'Отклонен ЦК',

  expertsApproved: 'Одобрен ЭГ',
  expertsDeclined: 'Отклонен ЭГ',
  approved: 'Утвержден',
  '-approved': 'Утвержден*',
  closed: 'Закрыт',
  moved: 'Перемещен'
};

export const status_ru_extra = {
  draft: 'Черновик',
  onApprovePortf: 'У руководителя портфеля',
  onApproveHeadSP: 'У руководителя СП',
  returnedByHeadSP: 'На доработке',
  onApproveExperts: 'На рассмотрении ЭГ',

  onApproveCommittee: 'На рассмотрении ЦК',
  committeeApproved: 'Одобрен ЦК',
  committeeDeclined: 'Отклонен ЦК',

  expertsApproved: 'Одобрен ЭГ',
  expertsDeclined: 'Отклонен ЭГ',
  approved: 'Утвержден',
  '-approved': 'Утвержден*',
  closed: 'Закрыт'
};

export const statusRuExtraWithPolicy = {
  ...status_ru_extra,
  onApproveHeadSP: 'У руководителя политики',
}

export function filterStatus(term, rowData) {
  if (term.includes('returnedByHeadSP')) {
    return term.includes(rowData.status) || ['returnedByPortf', 'returnedByExperts', 'returnedByCommittee'].includes(rowData.status);
  }
  return term.length === 0 || term.includes(rowData.status);
}

export const status_full = {
  created: { key: status.created, label: 'Новый', bg: 'secondary' },
  draft: { key: status.draft, label: 'Черновик', bg: 'secondary' },
  onApprovePortf: {
    key: status.onApprovePortf,
    label: status_ru.onApprovePortf,
    bg: 'warning',
  },
  returnedByPortf: {
    key: status.returnedByPortf,
    label: status_ru.returnedByPortf,
    bg: 'danger',
  },
  onApproveHeadSP: {
    key: status.onApproveHeadSP,
    label: status_ru.onApproveHeadSP,
    bg: 'warning',
  },
  returnedByHeadSP: {
    key: status.returnedByHeadSP,
    label: status_ru.returnedByHeadSP,
    bg: 'danger',
  },
  onApproveExperts: {
    key: status.onApproveExperts,
    label: status_ru.onApproveExperts,
    bg: 'warning',
  },
  returnedByExperts: {
    key: status.returnedByExperts,
    label: status_ru.returnedByExperts,
    bg: 'danger',
  },
  onApproveCommittee: {
    key: status.onApproveCommittee,
    label: status_ru.onApproveCommittee,
    bg: 'warning',
  },
  returnedByCommittee: {
    key: status.returnedByCommittee,
    label: status_ru.returnedByCommittee,
    bg: 'danger',
  },
  committeeApproved: {
    key: status.committeeApproved,
    label: status_ru.committeeApproved,
    bg: 'success',
  },
  committeeDeclined: {
    key: status.committeeDeclined,
    label: status_ru.committeeDeclined,
    bg: 'danger',
  },
  expertsApproved: {
    key: status.expertsApproved,
    label: status_ru.expertsApproved,
    bg: 'success',
  },
  expertsDeclined: {
    key: status.expertsDeclined,
    label: status_ru.expertsDeclined,
    bg: 'danger',
  },
  prolongation: { key: status.prolongation, label: 'Пролонгация', bg: 'primary' },
  approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
  '-approved': { key: status['-approved'], label: status_ru['-approved'], bg: 'success' },
  closed: { key: status.closed, label: status_ru.closed, bg: 'secondary' },
  moved: {key: status.moved, label: status_ru.moved, bg: 'secondary'}
};

export const statusFullWithPolicy = {
  ...status_full,
  onApproveHeadSP: {
    key: status.onApproveHeadSP,
    label: status_ru.onApproveHeadPolicy,
    bg: 'warning',
  },
}

export const statusFullWithGoal = {
  ...status_full,
  onApproveHeadSP: {
    key: status.onApproveHeadSP,
    label: status_ru.onApproveHeadGoal,
    bg: 'warning',
  },
}

export const statusFullWithTech = {
  ...status_full,
  onApproveHeadSP: {
    key: status.onApproveHeadSP,
    label: status_ru.onApproveHeadTech,
    bg: 'warning',
  },
}

export const getCurrentStyle = (currentStatus, data, acceptedData, property, listElement = null) => {
  const statusInclude = [status.draft, status.onApproveHeadSP, status.onApprovePortf, status.onApproveCommittee, status.onApproveExperts, status.approved].includes(currentStatus);
  const isAcceptedEmpty = _.isEmpty(acceptedData)
  const isDataEmpty = _.isEmpty(data)

  if (isDataEmpty || !statusInclude || isAcceptedEmpty ) return {color:''}
  if(statusInclude) {
    const dataProp = property.split('.').reduce((a,b)=>a?.hasOwnProperty(b) ? a[b] : a,data)
    const acceptedDataProp = property.split('.').reduce((a,b)=>a?.hasOwnProperty(b) ? a[b] : a,acceptedData)
    return  getHashJsonStringifyObject(dataProp) === getHashJsonStringifyObject(acceptedDataProp)
        ? {color: ''}
        : {width: 'fit-content', background: `${YELLOW_BACKGROUND_JS} no-repeat`};
  }};

export function getName(person) {
  const name = person.displayName ? person.displayName : `${person.lastName} ${person.firstName} ${person.middleName || ''}`
  const post = person.post ? ` (${person.post})` : ''
  return name + post
}
